import { render, staticRenderFns } from "./BooleanField.vue?vue&type=template&id=54c65687&scoped=true"
import script from "./BooleanField.vue?vue&type=script&lang=js"
export * from "./BooleanField.vue?vue&type=script&lang=js"
import style0 from "./BooleanField.vue?vue&type=style&index=0&id=54c65687&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c65687",
  null
  
)

export default component.exports